module.exports = __webpack_public_path__ + "static/be278720924df596e9e670addd9bcd17d9b30146f99d4da376c8d795c1ff4a47-83de9d7a22bfb842f23d02cbaf00301d.png";